import Hero from "../components/Hero";
import HeroImage from "../../assets/images/New8.jpg";
import { ReactComponent as ArrowLeft } from "../../assets/icons/implementation.svg";
import { ReactComponent as PencilSquare } from "../../assets/icons/edit.svg";
import { ReactComponent as Tie } from "../../assets/icons/management.svg";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";


const FeesPage = () => {
    const navigate = useNavigate();
  return (
    <div className="fees-page">
      <Hero
        title="Our Fees"
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
        lightOverlay={true}
      />
      <div className="primary-background-container-content">
        <h2 className="light">Initial Meeting is at our expense</h2>
        <p className="fees-description">
          Our fee structure is designed to be transparent and straightforward,
          ensuring you understand exactly what you’re paying for and how it
          supports your financial goals.
        </p>

        <div className="card-grid">
                  <div className="testimonial-card">
                      <PencilSquare />
            <div className="subtitle">Creation of a Foundations</div>
            <div className="content">£3000</div>
          </div>
                  <div className="testimonial-card">
                      <ArrowLeft />
            <div className="subtitle">Implementation fee</div>
            <div className="content">1% of transferred balance</div>
          </div>
                  <div className="testimonial-card">
                        <Tie />
            <div className="subtitle">Ongoing management charge</div>
            <div className="content">1% of amount invested</div>
          </div>
              </div>
              <Button text="CONTACT US" variant="primary"
                  onClick={() => {
                    navigate("/contact");
                      
                   }}
              />
      </div>
    </div>
  );
};

export default FeesPage;